// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"900cba73","206":"1751319a","221":"477cfdf4","392":"4cfa37a8","541":"aa6d6df6","584":"5171c0b1","670":"4a216dd1","773":"de6b1077","808":"98004144","821":"1c793e4f","919":"29611498"}[chunkId] + ".chunk.css";
};